import { styled } from 'lib/ui';

export const NotesListContainerStyled = styled.div`
  margin-right: -${p => p.theme.space};
  padding: ${p => p.theme.spaceSmall};
  height: 100%;
`;
